import { useRef, useState } from "react";
import styles from "./style.module.css";
import { AuthButton, Description } from "../../index";
import QRCode from "react-qr-code";
import { useReactToPrint } from "react-to-print";
import useAuth from "../../../hooks/useAuth";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { useNavigate } from "react-router-dom";

// pdfMake.vfs = pdfFonts.pdfMake.vfs;

const TicketBox = ({
  className,
  logo,
  photo,
  ticket,
  handleCheckin = () => {},
  handleUseTicket = () => {},
  ...props
}) => {
  const { auth } = useAuth();
  const componentRef = useRef();

  const navigation = useNavigate();

  const dd = {
    content: [
      {
        width: 114,
        height: 114,
        image: "okkologo",
        alignment: "center",
        margin: [0, 10],
      },
      {
        columns: [
          [
            {
              stack: [
                "İsim Soyisim",
                {
                  text: "Mertcan Köse",
                  style: "subheader",
                },
              ],
              style: "header",
              margin: [0, 6],
            },
            {
              stack: [
                "Telefon Numarası",
                {
                  text: "905433175846",
                  style: "subheader",
                },
              ],
              style: "header",
              margin: [0, 6],
            },
            {
              stack: [
                "Tarih",
                {
                  text: "16/06/2000",
                  style: "subheader",
                },
              ],
              style: "header",
              margin: [0, 6],
            },
            {
              stack: [
                "Saat",
                {
                  text: "14:00",
                  style: "subheader",
                },
              ],
              style: "header",
              margin: [0, 6],
            },
            {
              stack: [
                "Mekan",
                {
                  text: "Zippline",
                  style: "subheader",
                },
              ],
              style: "header",
              margin: [0, 6],
            },
            {
              stack: [
                "Toplam Fiyat",
                {
                  text: "100TL (NAKİT)",
                  style: "subheader",
                },
              ],
              style: "header",
              margin: [0, 6],
            },
          ],
          [
            {
              stack: [
                "Ödeme Durumu",
                {
                  text: "Ödendi",
                  style: "subheader",
                },
              ],
              style: "header",
              margin: [0, 6],
            },
            {
              stack: [
                "Check-In Durumu",
                {
                  text: "Yapıldı",
                  style: "subheader",
                },
              ],
              style: "header",
              margin: [0, 6],
            },
            {
              stack: [
                "Kullanım DUrumu",
                {
                  text: "Kullanıldı",
                  style: "subheader",
                },
              ],
              style: "header",
              margin: [0, 6],
            },
            {
              stack: [
                "PNR",
                {
                  text: "aaaaaaaa",
                  style: "subheader",
                },
              ],
              style: "header",
              margin: [0, 20],
            },
          ],
        ],
        margin: [0, 10],
      },
    ],
    images: {
      okkologo:
        "data:image/png;base64,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",
    },
    styles: {
      header: {
        fontSize: 14,
        bold: true,
      },
      subheader: {
        fontSize: 11,
        bold: false,
      },
      bigger: {
        fontSize: 15,
        italics: true,
      },
    },
    defaultStyle: {
      columnGap: 20,
    },
  };

  const [url, setUrl] = useState(null);

  const createPdf = () => {
    const pdfGenerator = pdfMake.createPdf(dd);
    pdfGenerator.download("bilet.pdf");
  };

  const printDocument = () => {
    const input = document.getElementById("divToPrint");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "pt", "a4");
      pdf.addImage(imgData, "PNG", 0, 0);
      // pdf.output('dataurlnewwindow');
      pdf.save("bilet.pdf");
    });
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <div className={[styles.pagesbox, className].join(" ")} {...props}>
        {/* <BusinessesBox
          // className="xss:w-[272px] w-[240px] xss:h-[400px] h-[352px]"
          logo={logo}
          photo={`${API_URL}` + ticket?.branch_image}
        >
          {ticket?.branch_name}
        </BusinessesBox> */}

        {/* xl:min-w-[955px] xl:h-[460px] */}
        <div
          className={styles.ticketInfoContainer}
          ref={componentRef}
          id="divToPrint"
        >
          {/* grid xl:grid-cols-3  */}
          <div className="w-full flex flex-col md:flex-row justify-between">
            <div className="w-full">
              <Description className={styles.ticketButtonBoxTitle}>
                {ticket?.ticket_name}
              </Description>
              <div className={styles.gridContainer}>
                <Description className={[styles.upperBoxTitleText].join(" ")}>
                  İsim Soyisim:
                </Description>
                <Description className={styles.upperBoxDescriptionText}>
                  {ticket?.name}
                </Description>
              </div>
              {/* <div className="grid xl:grid-cols-3 w-full">
                  <Description className={styles.upperBoxTitleText}>
                    TC NO:
                  </Description>
                  <Description className={styles.upperBoxDescriptionText}>
                    {ticket?.tc}
                  </Description>
                </div> */}
              <div className={styles.gridContainer}>
                <Description className={styles.upperBoxTitleText}>
                  Telefon Numarası:
                </Description>
                <Description className={styles.upperBoxDescriptionText}>
                  {ticket?.phone}
                </Description>
              </div>
              <div className={styles.gridContainer}>
                <Description className={styles.upperBoxTitleText}>
                  Tarih:
                </Description>
                <Description className={styles.upperBoxDescriptionText}>
                  {ticket?.meeting_date}
                </Description>
              </div>
              <div className={styles.gridContainer}>
                <Description className={styles.upperBoxTitleText}>
                  Saat:
                </Description>
                <Description className={styles.upperBoxDescriptionText}>
                  {ticket?.meeting_time} - {ticket?.meeting_end_time}
                </Description>
              </div>
              {/* <div className="grid xl:grid-cols-3 w-full">
                <Description className={styles.upperBoxTitleText}>
                  Bilet Türü:
                </Description>
                <Description
                  className={styles.upperBoxDescriptionText}
                ></Description>
              </div> */}
              <div className={styles.gridContainer}>
                <Description className={styles.upperBoxTitleText}>
                  Mekan:
                </Description>
                <Description className={styles.upperBoxDescriptionText}>
                  {ticket?.branch_name}
                </Description>
              </div>
              {/* <div className="grid xl:grid-cols-3 w-full">
                <Description className={styles.upperBoxTitleText}>
                  Kişiler:
                </Description>
                <Description className={styles.upperBoxDescriptionText}>
                  {persons}
                </Description>
              </div> */}
              <div className={styles.gridContainer}>
                <Description className={styles.upperBoxTitleText}>
                  Toplam Fiyat:{" "}
                </Description>
                <Description className={styles.upperBoxDescriptionText}>
                  {ticket?.price || ticket?.ticket_price}₺ ({ticket?.cash}{" "}
                  NAKİT)
                </Description>
              </div>

              <div className={styles.gridContainer}>
                <Description className={styles.upperBoxTitleText}>
                  Ödeme Durumu:{" "}
                </Description>
                <Description className={styles.upperBoxDescriptionText}>
                  {ticket?.is_purchased ? (
                    <span className="text-green-400">Ödeme Alındı</span>
                  ) : (
                    <span className="text-red-400 font-bold">
                      Ödeme Alınmadı
                    </span>
                  )}
                </Description>
              </div>

              <div className={styles.gridContainer}>
                <Description className={styles.upperBoxTitleText}>
                  Check-In Durumu:{" "}
                </Description>
                <Description className={styles.upperBoxDescriptionText}>
                  {ticket?.is_check_in || ticket?.meeting_check_in ? (
                    <span className="text-green-400">Check-In Yapıldı</span>
                  ) : (
                    <span className="text-red-400">Check-In Yapılmadı</span>
                  )}
                </Description>
              </div>

              <div className={styles.gridContainer}>
                <Description className={styles.upperBoxTitleText}>
                  Kullanım Durumu:{" "}
                </Description>
                <Description className={styles.upperBoxDescriptionText}>
                  {ticket?.is_completed ? (
                    <span className="text-green-400">Kullanıldı</span>
                  ) : (
                    <span className="text-red-400">Henüz Kullanılmadı</span>
                  )}
                </Description>
              </div>

              {/* <Description className={styles.upperBoxDescriptionText2}>
                Bilet Detayları ve Kurallar.
              </Description> */}
              <div className="h-full flex items-center justify-center"></div>
            </div>
            <div className="w-full mt-4 md:mt-0">
              <div className="h-full flex flex-col justify-center w-full items-start md:items-center">
                {ticket?.qr_code && (
                  <QRCode
                    value={ticket?.phone + "-" + ticket?.qr_code}
                    className="w-[200px] h-[200px] min-w-[200px] min-h-[200px] "
                  />
                )}

                <Description
                  className={[
                    styles.upperBoxDescriptionPnrText,
                    "text-left justify-start md:justify-center",
                  ].join(" ")}
                >
                  PNR: {ticket?.qr_code}
                </Description>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center mt-4">
        {auth?.role !== "normal" && (
          <AuthButton
            className="mt-4 px-6"
            onClick={() => {
              handleCheckin(ticket.phone, ticket.qr_code);
            }}
          >
            Check-In Yap
          </AuthButton>
        )}

        {auth?.role !== "normal" && (
          <AuthButton
            className="mt-4 px-6"
            onClick={() => {
              handleUseTicket(ticket.phone, ticket.qr_code);
            }}
          >
            Bileti Kullan
          </AuthButton>
        )}

        <AuthButton
          className="mt-4 px-6"
          onClick={() => {
            handlePrint();
            //printDocument();
            //createPdf();
          }}
        >
          Yazdır
          {/* <Link to={`/bilet?bilet=${JSON.stringify(ticket)}`} target="_blank">
            {" "}
            Yazdır
          </Link> */}
        </AuthButton>
      </div>
    </>
  );
};

export default TicketBox;
